import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ButtonBase from "@material-ui/core/ButtonBase";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { Link } from "react-router-dom";
import { utilSkipLeapYear } from "../../common/util";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { Storage } from "aws-amplify";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import { getDefect } from "../../graphql/queries";
import { spinnerService } from "@chevtek/react-spinners";
import gql from "graphql-tag";
import RedtagIcon from "../../assets/img/Redtag.PNG";
import StickerBG from "../../assets/img/stickerbackground.png";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { Col, Row } from "reactstrap";
// let defectiveImages = [];
// let imgModal = false;
const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#CCE5FF",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: 5,
    minHeight: 40,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: 2
  }
}))(MuiExpansionPanelDetails);

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2
  }
}))(MuiDialogContent);

export default function DashboardView({
  data,
  img,
  focus,
  client,
  history,
  usrGrp
}) {
  const [expanded, setExpanded] = useState("Active Defects");
  const Tabs_Array = [
    // { title: "Details", data: [] },
    { title: "Active Defects", data: [] },
    { title: "Archived Defects", data: [] },
    { title: "Inspections", data: [] }
  ];
  const InspectionsData = {
    regType: data.inspectionsData.regType,
    // info: data.data.getVehicle.inspections.items.sort(
    //   (a, b) => moment(b.endAt) - moment(a.endAt)
    info: data.inspectionsData.data.sort(
      (a, b) => moment(b.endAt) - moment(a.endAt)
    ),
    deactivateBIT: data.inspectionsData.deactivateBIT,
    deactivateDOT: data.inspectionsData.deactivateDOT,
    companyName: data.inspectionsData.companyName,
    customerVehicleId: data.inspectionsData.customerVehicleId,
    customerAddresses: data.inspectionsData.customerAddresses,
    nextDOT: data.inspectionsData.nextDOT,
    nextBIT: data.inspectionsData.nextBIT
  };
  const ActiveDefectsData = {
    head: ["Date", "Type", "Description", "Attachments", "Source", "Status"],
    info: data.activeDefsData
  };
  const ArchivedDefectsData = {
    head: ["Date", "Type", "Description", "Attachments", "Source", "Status"],
    info: data.archiveDefsData
  };
  let handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    if (focus === "Insp") {
      setExpanded("Inspections");
    } else if (focus === "Def") {
      if (ActiveDefectsData.info.length > 0) {
        setExpanded("Active Defects");
      } else {
        setExpanded("Archived Defects");
      }
    }
  }, []);
  return (
    <div style={{ marginTop: "8%" }}>
      <Typography variant="title">
        {" "}
        Vehicle Details For : {data.customerVehicleId}
      </Typography>
      {Tabs_Array.map(dt => {
        return (
          <ExpansionPanel
            key={dt.title}
            square
            expanded={expanded === dt.title}
            onChange={handleChange(dt.title)}
          >
            <ExpansionPanelSummary
              aria-controls={`${dt.title}d-content`}
              id={`${dt.title}d-header`}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography>{dt.title}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails id={dt.title}>
              {dt.title === "Active Defects" && (
                <CustomizedTable
                  data={ActiveDefectsData}
                  type={"ActDef"}
                  client={client}
                  usrGrp={usrGrp}
                />
              )}
              {dt.title === "Archived Defects" && (
                <CustomizedTable
                  data={ArchivedDefectsData}
                  type={"ArcDef"}
                  client={client}
                  usrGrp={usrGrp}
                />
              )}
              {dt.title === "Inspections" && (
                <InspectionTable
                  data={InspectionsData}
                  client={client}
                  history={history}
                  usrGrp={usrGrp}
                />
              )}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </div>
  );
}

export function ComplexGrid({ img, data }) {
  return (
    <div style={{ flexGrow: 1 }}>
      <Paper
        style={{
          padding: "6px",
          margin: "4px"
        }}
      >
        <Grid container spacing={16}>
          <Grid item>
            <ButtonBase
              style={{
                width: 100,
                height: 100
              }}
            >
              <img
                style={{
                  margin: "auto",
                  display: "block",
                  maxWidth: "100%",
                  maxHeight: "100%"
                }}
                alt="Vehicle Pic"
                src={img}
              />
            </ButtonBase>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={12}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {data.VehType}
                </Typography>
                <Typography color="textSecondary">ID: {data.id}</Typography>
                <Typography color="textSecondary">{data.vehStatus}</Typography>
              </Grid>
              <Grid item>
                {/* <Typography color="textSecondary">ID: {data.id}</Typography> */}
              </Grid>
            </Grid>
            <Grid item style={{ paddingRight: "12px" }}>
              {data.make && (
                <Typography variant="textSecondary">
                  Make: {data.make}
                </Typography>
              )}
              {data.model && (
                <Typography variant="textSecondary">
                  Model: {data.model}
                </Typography>
              )}
              <Typography>
                <div>
                  VIN: {data.vin.slice(0, 9).toString()}
                  <strong style={{ fontSize: 17, fontWeight: "bolder" }}>
                    {data.vin.slice(9, 11).toString()}
                  </strong>
                  <strong style={{ fontSize: 18, fontWeight: "bolder" }}>
                    <i>{data.vin.slice(11, 17).toString()}</i>
                  </strong>
                </div>
              </Typography>
            </Grid>
            {/* <Grid item>
              <Typography variant="subtitle1">
                {data.defectsCount} Active Defects
              </Typography>
              <Typography variant="subtitle1">{data.dvir} DVIR </Typography>
              <Typography variant="subtitle1">{data.otf} On The Fly</Typography>
            </Grid> */}
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

const CustomTableCell = withStyles(() => ({
  head: {
    backgroundColor: "white",
    color: "black",
    fontSize: 14
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

export function CustomizedTable({ data, type, client, usrGrp }) {
  const [loadingImages, setLoadingImages] = useState(true);
  let ActiveDefData = {
    head: data.head,
    rows: data.info.sort(
      (a, b) => moment(b.reportedDateTime) - moment(a.reportedDateTime)
    )
  };
  let ArchiveDefData = {
    head: data.head,
    rows: data.info.sort(
      (a, b) => moment(b.reportedDateTime) - moment(a.reportedDateTime)
    )
  };
  useEffect(() => {
    setTimeout(() => {
      setLoadingImages(false);
    }, 5000);
  }, []);
  const DataTable = () => {
    const [showMore, setShowMore] = useState(false);
    const [dispMore, setDispMore] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [activeRow, setActiveRow] = useState(1);
    const [activeImg, setActiveImg] = useState(1);
    const handleShowMore = (flag, id) => {
      setShowMore(flag);
      if (flag === true) {
        setDispMore(id);
      } else {
        setDispMore("");
      }
    };
    const handleChangePage = (event, page) => {
      setPage(page);
    };
    const handleChangeRowsPerPage = event => {
      setRowsPerPage(event.target.value);
    };

    const DefectsImgDisplay = ({ row, x }) => {
      return (
        <React.Fragment>
          {!loadingImages ? (
            <React.Fragment>
              {row.defectUploads && row.defectUploads.length > 0
                ? row.defectUploads.map((dt, i) => {
                    return (
                      <div key={dt}>
                        {activeImg === i + 1 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row"
                            }}
                          >
                            {activeImg !== 1 && row.defectUploads.length > 1 && (
                              <span
                                onClick={() => {
                                  setActiveRow(x);
                                  if (activeRow === x) {
                                    setActiveImg(prev => prev - 1);
                                  }
                                }}
                              >
                                {"<"}
                              </span>
                            )}
                            <span>
                              <Typography
                                style={{
                                  cursor: "pointer",
                                  color: "blue"
                                }}
                                onClick={() => window.open(dt)}
                              >
                                {`Image(${activeImg})`}
                              </Typography>
                            </span>
                            {activeImg !== row.defectUploads.length &&
                              row.defectUploads.length > 1 && (
                                <span
                                  onClick={() => {
                                    setActiveRow(x);
                                    if (activeRow === x) {
                                      setActiveImg(prev => prev + 1);
                                    }
                                  }}
                                >
                                  {">"}
                                </span>
                              )}
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    );
                  })
                : "No Attachments"}
            </React.Fragment>
          ) : (
            "Loading..."
          )}
        </React.Fragment>
      );
    };

    const DescDisplay = ({ desc, id, redtag }) => {
      return (
        <div
          style={{
            dislay: "flex",
            flexDirection: "row"
          }}
        >
          <div>
            {redtag && (
              <img src={RedtagIcon} alt="redTag" height="8%" width="8%" />
            )}
          </div>
          {desc.length > 20 ? (
            <div>
              {!showMore ? (
                <Typography>
                  {desc.slice(0, 20)}...
                  <Typography
                    style={{
                      fontSize: "10px",
                      color: "rgb(50, 136, 255)",
                      cursor: "pointer"
                    }}
                    onClick={() => handleShowMore(true, id)}
                  >
                    Show More
                  </Typography>
                </Typography>
              ) : (
                <div>
                  {dispMore === id ? (
                    <Typography>
                      {desc}
                      <Typography
                        style={{
                          fontSize: "10px",
                          color: "rgb(50, 136, 255)",
                          cursor: "pointer"
                        }}
                        onClick={() => handleShowMore(false, id)}
                      >
                        Show Less
                      </Typography>
                    </Typography>
                  ) : (
                    <Typography>
                      {desc.slice(0, 20)}...
                      <Typography
                        style={{
                          fontSize: "10px",
                          color: "rgb(50, 136, 255)",
                          cursor: "pointer"
                        }}
                        onClick={() => handleShowMore(true, id)}
                      >
                        Show More
                      </Typography>
                    </Typography>
                  )}
                </div>
              )}
            </div>
          ) : (
            <Typography>{desc} </Typography>
          )}
        </div>
      );
    };
    return (
      <div>
        <Paper>
          <Table
            padding="checkbox"
            style={{
              maxWidth: "100%",
              maxHeight: "50%"
            }}
          >
            <TableHead>
              {type === "ActDef" && (
                <TableRow>
                  {ActiveDefData.head.map(h => (
                    <CustomTableCell key={h}>{h}</CustomTableCell>
                  ))}
                </TableRow>
              )}
              {type === "ArcDef" && (
                <TableRow>
                  {ArchiveDefData.head.map(h => (
                    <CustomTableCell key={h}>{h}</CustomTableCell>
                  ))}
                </TableRow>
              )}
            </TableHead>
            {ActiveDefData.rows.length > 0 || ArchiveDefData.rows.length > 0 ? (
              <TableBody>
                {type === "ActDef" ? (
                  <React.Fragment>
                    {ActiveDefData.rows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, i) => (
                        <TableRow key={row.id}>
                          <CustomTableCell>
                            {moment(
                              new Date(row.reportedDateTime)
                                .toISOString()
                                .split("T")[0]
                            ).format("MM-DD-YYYY")}
                          </CustomTableCell>
                          <CustomTableCell>{row.defectType}</CustomTableCell>
                          <CustomTableCell>
                            {row.defectDesc !== null ? (
                              <CustomTableCell align="right">
                                <DescDisplay
                                  desc={row.defectDesc}
                                  id={row.id}
                                  redtag={row.redTag}
                                />
                              </CustomTableCell>
                            ) : (
                              "--No Description--"
                            )}
                          </CustomTableCell>
                          <CustomTableCell>
                            <DefectsImgDisplay row={row} x={i + 1} />
                          </CustomTableCell>
                          <CustomTableCell>{row.sourceType}</CustomTableCell>
                          <CustomTableCell>
                            <Link
                              to={{
                                pathname:
                                  usrGrp === "Vendors"
                                    ? `/vendor/customer/${row.customer}/defects/work/order/${row.id}`
                                    : usrGrp === "Mechanics"
                                    ? `/mech/customer/${row.customer}/defects/work/order/${row.id}`
                                    : `/defects/work/order/${row.id}`,
                                state: {
                                  description: row.defectDesc,
                                  repairNotes: row.repairNotes,
                                  partsUsed: row.partsUsedInRepair,
                                  status: row.status
                                }
                              }}
                            >
                              {row.status}
                            </Link>
                          </CustomTableCell>
                        </TableRow>
                      ))}
                  </React.Fragment>
                ) : (
                  type === "ArcDef" && (
                    <React.Fragment>
                      {ArchiveDefData.rows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, i) => (
                          <TableRow key={row.id}>
                            <CustomTableCell>
                              {moment(
                                new Date(row.reportedDateTime)
                                  .toISOString()
                                  .split("T")[0]
                              ).format("MM-DD-YYYY")}
                            </CustomTableCell>
                            <CustomTableCell>{row.defectType}</CustomTableCell>
                            <CustomTableCell>
                              {row.defectDesc !== null ? (
                                <CustomTableCell align="right">
                                  <DescDisplay
                                    desc={row.defectDesc}
                                    id={row.id}
                                    redtag={row.redTag}
                                  />
                                </CustomTableCell>
                              ) : (
                                "--No Description--"
                              )}
                            </CustomTableCell>
                            <CustomTableCell>
                              <DefectsImgDisplay row={row} x={i + 1} />
                            </CustomTableCell>
                            <CustomTableCell>{row.sourceType}</CustomTableCell>
                            <CustomTableCell>
                              <Link
                                to={{
                                  pathname:
                                    usrGrp === "Vendors"
                                      ? `/vendor/customer/${row.customer}/defects/work/order/${row.id}`
                                      : usrGrp === "Mechanics"
                                      ? `/mech/customer/${row.customer}/defects/work/order/${row.id}`
                                      : `/defects/work/order/${row.id}`,
                                  state: {
                                    description: row.defectDesc,
                                    repairNotes: row.repairNotes,
                                    partsUsed: row.partsUsedInRepair,
                                    status: row.status
                                  }
                                }}
                              >
                                {row.status}
                              </Link>
                            </CustomTableCell>
                          </TableRow>
                        ))}
                    </React.Fragment>
                  )
                )}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={6}>
                    <div
                      style={{
                        marginLeft: "45%",
                        fontSize: 16
                      }}
                    >
                      {"No record found"}
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
          {type === "ArcDef" ? (
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={ArchiveDefData.rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page"
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page"
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          ) : (
            type === "ActDef" && (
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={ActiveDefData.rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            )
          )}
        </Paper>
      </div>
    );
  };

  return (
    <Paper
      style={{
        width: "100%",
        marginTop: 3,
        overflowX: "auto"
      }}
    >
      <React.Fragment>
        <DataTable />
      </React.Fragment>
    </Paper>
  );
}

export function InspectionTable({ data, history, client, usrGrp }) {
  // const address = `${data.customerAddresses.address} ${data.customerAddresses.city} ${data.customerAddresses.state} ${data.customerAddresses.zipCode}`;
  const dotAnnual = data.info.filter(
    a =>
      a.inspectionType === "DOT_ANNUAL_INSPECTION" ||
      a.inspectionType === "DOTANDBIT"
  );
  const bit90 = data.info.filter(
    a =>
      a.inspectionType === "BIT_90DAY_INSPECTION" ||
      a.inspectionType === "DOTANDBIT"
  );

  const StickerDisplay = props => {
    return (
      <div
        style={{
          minHeight: "380px",
          minWidth: "70%",
          maxWidth: "70%",
          backgroundColor: "#000082",
          border: "8px solid white ",
          float: "right",
          padding: "16px 0px 0px 30px"
        }}
      >
        <Row>
          <Col sm={10}>
            <Row>
              <div
                style={{
                  color: "rgb(154, 156, 159)",
                  fontSize: "27px"
                }}
              >
                Commercial Vehicle
              </div>
            </Row>
            <Row>
              <div
                style={{
                  color: "rgb(154, 156, 159)",
                  fontSize: "25px"
                }}
              >
                FEDERAL ANNUAL INSPECTION
              </div>
            </Row>
            <Row>
              <div
                style={{
                  color: "rgb(154, 156, 159)",
                  fontSize: "18px"
                }}
              >
                In accordance with FMCSA 49 CFR part 396.17 through 396.23
              </div>
            </Row>
          </Col>
          <Col sm={2}>
            <div
              style={{
                position: "absolute",
                top: "12px",
                right: "0",
                transform: "rotate(90deg)",
                color: "rgb(154, 156, 159)",
                fontSize: "24px"
              }}
            >
              CalBIT
            </div>
          </Col>
        </Row>

        <Row>
          <Col
            sm={3}
            style={{
              paddingTop: "2px"
            }}
          >
            <div
              style={{
                width: "130px",
                height: "50px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "1px solid #000082"
              }}
            >
              <div
                style={{
                  fontSize: "14px"
                }}
              >
                Inspection Date
              </div>
              <div>
                <span
                  style={{
                    textDecoration: "line-through",
                    fontSize: "12px"
                  }}
                >
                  cross out
                </span>
                <span
                  style={{
                    fontSize: "12px"
                  }}
                >
                  old dates
                </span>
              </div>
            </div>
          </Col>
          <Col sm={2}>
            <div
              style={{
                width: "130px",
                height: "65px",
                padding: "14px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "1px solid #000082"
              }}
            >
              {props.dates[3] && props.dates.length > 3 ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[3].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[2] ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[2].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[1] ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[1].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[0] ? (
                <div style={{ textDecoration: "none" }}>
                  {moment(
                    new Date(props.dates[0].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col sm={2}>
            <div
              style={{
                width: "130px",
                height: "65px",
                padding: "14px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "1px solid #000082"
              }}
            >
              {props.dates[2] && props.dates.length > 3 ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[2].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[1] ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[1].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[0] ? (
                <div style={{ textDecoration: "none" }}>
                  {moment(
                    new Date(props.dates[0].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col sm={2}>
            <div
              style={{
                width: "130px",
                height: "65px",
                padding: "14px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "1px solid #000082"
              }}
            >
              {props.dates[1] && props.dates.length > 3 ? (
                <span style={{ textDecoration: "line-through" }}>
                  {moment(
                    new Date(props.dates[1].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </span>
              ) : props.dates[0] ? (
                <div style={{ textDecoration: "none" }}>
                  {moment(
                    new Date(props.dates[0].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col sm={2}>
            <div
              style={{
                width: "120px",
                height: "65px",
                padding: "14px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "1px solid #000082"
              }}
            >
              {props.dates[0] && props.dates.length > 3 ? (
                <div style={{ textDecoration: "none" }}>
                  {moment(
                    new Date(props.dates[0].endAt).toISOString().split("T")[0]
                  ).format("MM-DD-YYYY")}
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={5}>
            <div
              style={{
                color: "rgb(154, 156, 159)",
                padding: "2px"
              }}
            >
              This Vehicle Has Passed its Annual Inspection on the Above date(s)
            </div>
            <div
              style={{
                color: "rgb(154, 156, 159)",
                padding: "2px"
              }}
            >
              Inspection Report Record(s) Maintained at:
            </div>
          </Col>

          <Col sm={7}>
            <div
              style={{
                width: "98%",
                height: "40px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "3px solid #000082",
                padding: "4px 2px"
              }}
            >
              <Row
                style={{
                  width: "95%",
                  paddingLeft: "25px"
                }}
              >
                <span style={{ color: "#000082" }}>Vehicle ID: </span>
                <span style={{}}>{props.id} </span>
              </Row>
            </div>

            <div
              style={{
                width: "98%",
                height: "150px",
                backgroundColor: "rgb(154, 156, 159)",
                border: "3px solid #000082",
                padding: "4px 2px"
              }}
            >
              <Row
                style={{
                  width: "95%",
                  paddingLeft: "25px"
                }}
              >
                <span style={{ color: "#000082" }}>
                  Carrier:
                  <span style={{ color: "black" }}>{props.company} </span>
                </span>
              </Row>
              <Row
                style={{
                  width: "95%",
                  paddingLeft: "25px"
                }}
              >
                <span style={{ color: "#000082" }}>
                  Address:
                  <span style={{ color: "black" }}>{props.address} </span>
                </span>
              </Row>
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={4}>
            <div
              style={{
                fontSize: "10px",
                color: "rgb(154,156,159)"
              }}
            >
              &copy; CopyRight 2016 CalBIT.com
            </div>
          </Col>
          <Col sm={3}>
            <div
              style={{
                fontSize: "10px",
                color: "rgb(154,156,159)"
              }}
            >
              All Rights Reserved
            </div>
          </Col>
          <Col sm={2}>
            <div
              style={{
                fontSize: "10px",
                color: "rgb(154,156,159)"
              }}
            >
              (Rev .09/16)
            </div>
          </Col>
          <Col sm={3}>
            <div
              style={{
                fontSize: "10px",
                color: "rgb(154,156,159)"
              }}
            >
              Re-order at www.calbit.com
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  useEffect(() => {}, []);
  return (
    <div
      style={{
        flexGrow: 1
      }}
    >
      <Grid container spacing={24}>
        {["FEDERAL_BIT", "BIT"].includes(data.regType) && !data.deactivateBIT && (
          <Grid item xs={12} sm={6}>
            <Paper
              style={{
                padding: 5,
                textAlign: "center",
                color: "secondary"
              }}
            >
              {bit90.length > 0 ? (
                <Typography>
                  Next 90-Day BIT Due By:{" "}
                  {moment(
                    utilSkipLeapYear("BIT_90DAY_INSPECTION", bit90[0].endAt)
                  ).format("MM-DD-YYYY")}{" "}
                </Typography>
              ) : (
                <Typography>
                  Next 90-Day BIT Due By:{" "}
                  {" " + moment(data.nextBIT).format("MM-DD-YYYY")}
                </Typography>
              )}
              <Typography style={{ paddingTop: "21px" }} variant="title">
                90-Day BIT History
              </Typography>
              <Table
                padding="checkbox"
                style={{
                  width: "100%",
                  maxHeight: "50%"
                }}
              >
                <TableHead>
                  <TableRow>
                    <CustomTableCell> Inspected On: </CustomTableCell>
                    <CustomTableCell> Next Inspection Due: </CustomTableCell>
                  </TableRow>
                </TableHead>
                {bit90.length > 0 ? (
                  <TableBody>
                    {bit90.slice(0, 8).map((v, i) => (
                      <TableRow key={i}>
                        <CustomTableCell>
                          <Link
                            to={{
                              pathname:
                                usrGrp === "Vendors"
                                  ? `/vendor/customer/${v.customer}/vehicle/inspection/${v.id}`
                                  : usrGrp === "Mechanics"
                                  ? `/mech/customer/${v.customer}/vehicle/inspection/${v.id}`
                                  : `inspection/${v.id}`,
                              // focus: "Def"
                              client: { client }
                            }}
                          >
                            {" "}
                            {moment(
                              new Date(v.endAt).toISOString().split("T")[0]
                            ).format("MM-DD-YYYY")}
                          </Link>
                        </CustomTableCell>
                        {data.regType !== "FEDERAL_BIT" ? (
                          <CustomTableCell>
                            {" "}
                            {moment(v.nextInspectionDue).format(
                              "MM-DD-YYYY"
                            )}{" "}
                          </CustomTableCell>
                        ) : (
                          <CustomTableCell>
                            {" "}
                            {moment(
                              utilSkipLeapYear("BIT_90DAY_INSPECTION", v.endAt)
                            ).format("MM-DD-YYYY")}{" "}
                          </CustomTableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <CustomTableCell colSpan={2}>
                        {" "}
                        <div
                          style={{
                            alignContent: "center",
                            justifyContent: "center",
                            marginLeft: "45%",
                            fontSize: 16
                          }}
                        >
                          {" "}
                          No History{" "}
                        </div>{" "}
                      </CustomTableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </Paper>
          </Grid>
        )}
        {data.deactivateBIT && (
          <Grid item xs={12} sm={6}>
            <Paper
              style={{
                padding: 5,
                textAlign: "center",
                color: "secondary"
              }}
            >
              <Typography variant="title">BIT Deactivated</Typography>
            </Paper>
          </Grid>
        )}
        {["FEDERAL_BIT", "FEDERAL"].includes(data.regType) &&
          !data.deactivateDOT && (
            <Grid item xs={12} sm={6}>
              <Paper
                style={{
                  padding: 5,
                  textAlign: "center",
                  color: "secondary"
                }}
              >
                {dotAnnual.length > 0 ? (
                  <Typography>
                    Next DOT Annual Due By:{" "}
                    {moment(
                      utilSkipLeapYear(
                        "DOT_ANNUAL_INSPECTION",
                        dotAnnual[0].endAt
                      )
                    ).format("MM-DD-YYYY")}{" "}
                  </Typography>
                ) : (
                  <Typography>
                    Next DOT Annual Due By:{" "}
                    {" " + moment(data.nextDOT).format("MM-DD-YYYY")}
                  </Typography>
                )}
                <Typography style={{ paddingTop: "21px" }} variant="title">
                  DOT Annual History
                </Typography>
                <Table
                  cellSpacing="3"
                  padding="checkbox"
                  style={{
                    width: "100%",
                    maxHeight: "50%"
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <CustomTableCell> Inspected On:</CustomTableCell>
                      <CustomTableCell> Next Inspection Due: </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  {dotAnnual.length > 0 ? (
                    <TableBody>
                      {dotAnnual.slice(0, 8).map((v, i) => (
                        <TableRow key={i}>
                          <CustomTableCell>
                            <Link
                              to={{
                                pathname:
                                  usrGrp === "Vendors"
                                    ? `/vendor/customer/${v.customer}/vehicle/inspection/${v.id}`
                                    : usrGrp === "Mechanics"
                                    ? `/mech/customer/${v.customer}/vehicle/inspection/${v.id}`
                                    : `inspection/${v.id}`,
                                // focus: "Def"
                                client: { client }
                              }}
                            >
                              {" "}
                              {moment(
                                new Date(v.endAt).toISOString().split("T")[0]
                              ).format("MM-DD-YYYY")}
                            </Link>
                          </CustomTableCell>
                          {data.regType !== "FEDERAL_BIT" ? (
                            <CustomTableCell>
                              {" "}
                              {moment(v.nextInspectionDue).format(
                                "MM-DD-YYYY"
                              )}{" "}
                            </CustomTableCell>
                          ) : (
                            <CustomTableCell>
                              {" "}
                              {moment(
                                utilSkipLeapYear(
                                  "DOT_ANNUAL_INSPECTION",
                                  v.endAt
                                )
                              ).format("MM-DD-YYYY")}{" "}
                            </CustomTableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <CustomTableCell colSpan={2}>
                          {" "}
                          <div
                            style={{
                              alignContent: "center",
                              justifyContent: "center",
                              marginLeft: "45%",
                              fontSize: 16
                            }}
                          >
                            {" "}
                            No History{" "}
                          </div>{" "}
                        </CustomTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </Paper>
            </Grid>
          )}
        {data.deactivateDOT && (
          <Grid item xs={12} sm={6}>
            <Paper
              style={{
                padding: 5,
                textAlign: "center",
                color: "secondary"
              }}
            >
              <Typography variant="title">DOT Deactivated</Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
      {!data.deactivateDOT && dotAnnual.length > 0 && (
        <StickerDisplay
          dates={dotAnnual}
          id={data.customerVehicleId}
          address={data.customerAddresses}
          company={data.companyName}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/Company/NewVehicleDetail.js